
import React, { FC } from 'react';

import {
    AppTemplate
} from '@components/4-templates';

import {
    IconButton,
} from '@components/2-molecules';

import {
    ContactList,
} from '@components/3-organisms';

import { STATE } from '@lib/constants';
import { useContact } from '@lib/hooks/useContact';

import { ForwardedPageProps } from '@lib/constants';
import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
import Sandwich from '@assets/icons/sandwich';
import Add from '@assets/icons/plus';
import {
  PageHeader
} from '@components/2-molecules';

const Contacts: FC<ForwardedPageProps> = ({ navigation, ...props}) => {

    const [contacts,] = useContact({state: STATE.READY});
    // onNavigation(navigation, () => {setContacts(({state: STATE.READY}))});

    return (
        <AppTemplate hooks={[contacts]}>
        
            <PageHeader title={"CONTACTS"}
              left={<IconButton icon={<Sandwich />} onPress={navigation?.toggleDrawer} />}
              right={<IconButton icon={<Add/>} onPress={()=>{navigation.navigate('ContactCreate')}} />} />
            
            <ContactList
                color={contacts?.data?.length ? '#000' : '#FFF'}
                data={contacts.data}
                onPress={(contact)=>{navigation.navigate('ContactView', {data: contact})}}
            />

        </AppTemplate>
    );
};


export default withForwardedNavigationParams<ForwardedPageProps>()(Contacts);